<template>
  <div :class="$style.root">
    <div :class="$style.wrapper">
      <search />
      <sort v-if="$route.query.view === 'grid'" />
    </div>
    <div>
      <router-link
        :to="getRouterLink('table')"
        :class="[$style.button, { [$style.active]: $route.query.view === 'table' }]"
        replace
      >
        {{ $t('pages.table') }}
      </router-link>
      <router-link
        :to="getRouterLink('grid')"
        :class="[$style.button, { [$style.active]: $route.query.view === 'grid' }]"
        replace
      >
        {{ $t('pages.sketches') }}
      </router-link>
    </div>
    <div
      v-if="visible"
      ref="printContainer"
      :class="$style.hidden"
    >
      <screenshots-table />
    </div>
    <export />
  </div>
</template>

<script>
  import ScreenshotsTable from '@/components/common/export/screenshots-table.vue';
  import Search from '@/components/pages/computers/log/screenshots/components-header/search.vue';
  import Sort from '@/components/pages/computers/log/screenshots/components-header/sort.vue';
  import Export from '@/components/pages/computers/log/screenshots/components-header/export.vue';

  export default {
    components: {
      ScreenshotsTable,
      Search,
      Sort,
      Export,
    },
    props: {
      selectedComputer: {
        type: null,
        default: () => {},
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    methods: {
      getRouterLink(view) {
        return { query: { ...this.$route.query, view } };
      },
    },
  };
</script>

<style lang="scss" module>
  .root {
    display: flex;
    justify-content: space-between;
  }

  .wrapper {
    display: flex;
  }

  .button {
    background: $light-gray;
    border: 1px solid $borderColor;
    border-radius: 2px;
    color: $light-black;
    font-size: 14px;
    text-decoration: none;
    display: inline-block;
    padding: 10px 20px;
    transition: 0.1s ease-out;

    &:not(:last-child) {
      margin-right: 12px;
    }

    &.active {
      background: $light-blue;
      color: $blue;
    }
  }

  .hidden {
    display: none;
  }
</style>
